// @flow
import smoothScroll from 'smoothscroll'
import { HEADER_HEIGHT } from 'app/constants'

/**
 * Helper to scroll to the top of an element.
 * TODO: migrating smoothScroll direct usage to this.
 */
export function scrollToElemTop({
  elem,
  includeHeaderOffsetY = true,
  extraOffsetY = 0,
  ms = 500,
}: {
  elem: HTMLElement,
  includeHeaderOffsetY?: boolean,
  extraOffsetY?: number,
  ms?: number,
}) {
  // bounding box offset top
  if (elem) {
    const elemTop = elem.getBoundingClientRect().top

    // scroll offset
    let offset = window.pageYOffset

    if (includeHeaderOffsetY) {
      offset -= HEADER_HEIGHT
    }

    if (extraOffsetY) {
      offset -= extraOffsetY
    }

    const scrollTo = elemTop + offset

    smoothScroll(scrollTo, ms)
  }
}

/**
 * attached smooth scrolling to .go-to on dom load
 * can be the following formats (and accounts for header):
 * <a href="#" data-target="comments" class="comment-button go-to"></a>
 *
 * Note - that any <a href="#rea-anchor">link</a> is automatically picked up by smoothscroll
 * Note 2 -use class="scroll-dest" on any anchor id destination element.  It will handle header padding.
 */
function scrollToInit() {
  // scroll to functionality for class="go-to"
  const goToBtns = document.querySelectorAll('.go-to')

  for (let i = 0; i < goToBtns.length; i++) {
    goToBtns[i].addEventListener(
      'click',
      (e: MouseEvent) => {
        e.preventDefault()

        const elem = goToBtns[i]
        const dataTargetId = elem.getAttribute('data-target')

        if (dataTargetId) {
          // prevent page reload and scroll to element defined by data-target
          const targetId = goToBtns[i].getAttribute('data-target')
          const target = targetId && document.getElementById(targetId)
          const offsetTop = target && target.offsetTop

          offsetTop && smoothScroll(offsetTop - HEADER_HEIGHT, 500, () => {})
        }
      },
      false,
    )
  }
  // end class="go-to"
}

export default scrollToInit
